import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AcabimProject, AcabimSite, ProjectApiService, SiteApiService, Status} from '@cas-hub/acabim-common-client';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'acabim-admin-move-project',
    templateUrl: './move-project.component.html',
    styleUrls: ['./move-project.component.scss']
})
export class MoveProjectComponent implements OnInit {
    @Input() project?: AcabimProject;
    @Input() site?: AcabimSite;
    // tslint:disable-next-line:no-output-native
    @Output() close = new EventEmitter<boolean>();
    moveGroup = false;
    moveProjectForm: FormGroup;
    panelNum = 1;
    title = 'Choose A New Site';
    sites: AcabimSite[] = [];
    noSiteMessage = '';
    selectedSite?: AcabimSite;
    isLoading = false;

    constructor(private readonly siteApiService: SiteApiService, private readonly projectApiService: ProjectApiService) {
        this.moveProjectForm = new FormGroup({
            inputDropdownSelected: new FormControl(null, Validators.required),
            inputGroup: new FormControl()
        });
    }

    ngOnInit(): void {
        this.siteApiService.getAllSites(undefined, {
            includeCoordinates: false,
            includeGroups: false,
            includeProjects: false,
            filterStatus: Status.active
        }, true)
            .subscribe(val => {
                this.sites = val as AcabimSite[];
            });
    }

    navigateToGroupPage() {
        if (this.moveProjectForm.valid) {
            this.noSiteMessage = '';
            this.panelNum = 2;
        } else {
            this.noSiteMessage = 'please select a site to move';
        }
    }

    clearErrorMessage() {
        this.noSiteMessage = '';
    }

    onCancel() {
        this.selectedSite = undefined;
        this.moveGroup = false;
        this.moveProjectForm.reset();
        this.close.emit(false);

    }

    onComplete() {
        this.panelNum = 3;

        if (this.project && this.selectedSite) {
            this.isLoading = true;
            this.projectApiService.transferProjectToSite(this.project?.id, this.selectedSite.id, this.moveGroup).subscribe(data => {
                this.isLoading = false;
            });

        }
    }
}
